import { memo, type FC } from "react";
import { useTranslation } from "react-i18next";
import CampaignStepCard from "../../../../shared/CampaignStepCard";
import CampaignTextField from "../../../../shared/CampaignTextField";
import ChoiceCard from "../components/ChoiceCard";
import CustomChoicePanel from "../components/CustomChoicePanel";
import { CAMPAIGN_TYPE_OPTIONS, CUSTOM_OPTION } from "../AiCampaignConstants";
import type { AiCampaignForm, UpdateAiCampaignForm } from "../AiCampaignTypes";

const STEP_KEY = "campaignFlow.aiWizard.campaignCategory";
const CATEGORY_NAME_ID = "ai-campaign-custom-category";
const SUB_CATEGORY_NAME_ID = "ai-campaign-custom-sub-category";

interface CampaignCategoryStepProps {
  form: AiCampaignForm;
  updateForm: UpdateAiCampaignForm;
}

const CampaignCategoryStep: FC<CampaignCategoryStepProps> = ({ form, updateForm }) => {
  const { t } = useTranslation();

  return (
    <CampaignStepCard title={t(`${STEP_KEY}.title`)} subtitle={t(`${STEP_KEY}.subtitle`)}>
      <div className="choice-list" role="radiogroup" aria-label={t(`${STEP_KEY}.title`)}>
        {CAMPAIGN_TYPE_OPTIONS.map(option => (
          <ChoiceCard
            key={option.value}
            title={t(option.titleKey)}
            selected={form.campaignType === option.value}
            onSelect={() => updateForm("campaignType", option.value)}
          />
        ))}

        <ChoiceCard
          title={t(`${STEP_KEY}.customTitle`)}
          selected={form.campaignType === CUSTOM_OPTION}
          onSelect={() => updateForm("campaignType", CUSTOM_OPTION)}
          isCustom
        >
          <CustomChoicePanel
            title={t(`${STEP_KEY}.customPanelTitle`)}
            subtitle={t(`${STEP_KEY}.customPanelSubtitle`)}
          >
            <CampaignTextField
              id={CATEGORY_NAME_ID}
              label={t(`${STEP_KEY}.categoryName`)}
              value={form.customCampaignType}
              onChange={value => updateForm("customCampaignType", value)}
              placeholder={t(`${STEP_KEY}.categoryNamePlaceholder`)}
              required
            />
            <CampaignTextField
              id={SUB_CATEGORY_NAME_ID}
              label={t(`${STEP_KEY}.subCategoryName`)}
              value={form.customSubCampaign}
              onChange={value => updateForm("customSubCampaign", value)}
              placeholder={t(`${STEP_KEY}.subCategoryNamePlaceholder`)}
              required
            />
          </CustomChoicePanel>
        </ChoiceCard>
      </div>
    </CampaignStepCard>
  );
};

export default memo(CampaignCategoryStep);
